import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintManager_create_update_planService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { plan_id?: string, in_params: $frontendTypes.Manufacturing.CreateOrderCopiesParams, cron_expression: string, is_active: boolean }): Promise<{ reasons?: string[], plan_id?: string }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.in_params)) {
      missingRequiredInParams.push('\'in_params\'');
    }
    if (isNil(inParams.cron_expression)) {
      missingRequiredInParams.push('\'cron_expression\'');
    }
    if (isNil(inParams.is_active)) {
      missingRequiredInParams.push('\'is_active\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/functions/create_update_plan`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

